import { render, staticRenderFns } from "./OrderManagementNominative.vue?vue&type=template&id=3bccb5b9"
import script from "./OrderManagementNominative.vue?vue&type=script&lang=js"
export * from "./OrderManagementNominative.vue?vue&type=script&lang=js"
import style0 from "./OrderManagementNominative.vue?vue&type=style&index=0&id=3bccb5b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports